import * as styledComponents from 'styled-components';
import { ThemedStyledComponentsModule } from 'styled-components';

export interface ITheme {
  color: {
    body1: string;
    body2: string;
    body3: string;
  };
  maxWidth: string;
  mobilePadding: number;
  mobileBreakpoint: number;
  aboutBreakpoint: number;
  referenceMaxWidth: number;
}

type StyledFunction<T> = styledComponents.ThemedStyledFunction<T, ITheme>;

function tstyled<T, U extends HTMLElement = HTMLElement>(
  styledFunction: StyledFunction<React.HTMLProps<U>>
): StyledFunction<T & React.HTMLProps<U>> {
  return styledFunction;
}

const {
  default: styled,
  css,
  injectGlobal,
  keyframes,
  ThemeProvider,
} = styledComponents as ThemedStyledComponentsModule<ITheme>;

export { css, injectGlobal, keyframes, ThemeProvider, tstyled };

export default styled;



// WEBPACK FOOTER //
// ./src/theme/index.ts